export enum BadgeThemeEnum {
  PrimaryOnWhite,
  BlackOnWhite,
  WhiteOnBlack,
}
